import { useFeatureValue } from "@growthbook/growthbook-react";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import OriginalCTA0 from "./variants/OriginalCTA0";
import CopyCTA1 from "./variants/CopyCTA1";
import QuestionCTA2 from "./variants/QuestionCTA2";
import RadioCTA3 from "./variants/RadioCTA3";
import RadioAndCopyCTA4 from "./variants/RadioAndCopyCTA4";

import { i18n } from "i18next";

export interface DisruptedCTAProps {
  t: i18n["t"];
  onAnotherClaimReasonClick: () => void;
  onSubmit: (data: never) => Promise<void>;
  isSubmitting: boolean;
  isCancelled: boolean;
  disruptionReason: "cancelled" | "delayed";
}

function DisruptedCTA(props: DisruptedCTAProps) {
  const CTA_EXPERIMENT_NAME = "webapp-funnel-simplified-cta-test";
  const isCTAExperimentEnabled = useFeatureIsOn(CTA_EXPERIMENT_NAME);
  const CTAExperimentValue = useFeatureValue(CTA_EXPERIMENT_NAME, 0);

  if (!isCTAExperimentEnabled || CTAExperimentValue === 0) {
    return <OriginalCTA0 {...props} />;
  }

  switch (CTAExperimentValue) {
    case 1:
      return <CopyCTA1 {...props} />;
    case 2:
      return <QuestionCTA2 {...props} />;
    case 3:
      return <RadioCTA3 {...props} />;
    case 4:
      return <RadioAndCopyCTA4 {...props} />;
    default:
      return <OriginalCTA0 {...props} />;
  }
}

export { DisruptedCTA };
